import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';

import { URL } from '../../constant';
import useStarShop from '../../hooks/useStarShop';

function StarCntBtn({
  type,
  setTotal
}) {
  const history = useHistory();
  const { starCntAPI, totalCnt } = useStarShop();
  
  useEffect(() => {
    starCntAPI();
  }, [])

  useEffect(() => {
    if (setTotal) setTotal(totalCnt);
  }, [totalCnt])

  const handlePage = useCallback((page) => {
    history.push(page);
  }, []);

  return (
    <React.Fragment>
      {
        type === 'button'
          ? (
            <>
              <button
                className="star"
                type="button"
                onClick={() => handlePage(URL.STAR_SHOP_HISTORY)}
              >
                {totalCnt * 20}
              </button>
            </>
          )
          : (
            <div className="box">{totalCnt * 20}</div>
          )
      }
    </React.Fragment>
  );
}

export default StarCntBtn;